import React from 'react';
import { useDispatch } from 'react-redux';

import { Button } from '@videoblocks/storywind';

import { showPopUp } from '../../../PopUps/actions/PopUpsActions';
import { CREATE_NEW_FOLDER_MODAL } from '../../../PopUps/components/types';
import { addNewFolderWithStockItem } from '../../MemberBins/actions/FoldersActions';

export interface NoFoldersHeroPropTypes {
  isInSharedFoldersBeta: boolean;
}

const NoFoldersHero = ({ isInSharedFoldersBeta }: NoFoldersHeroPropTypes) => {
  const dispatch = useDispatch();
  const openNewFolderModal = () => {
    dispatch(
      showPopUp(CREATE_NEW_FOLDER_MODAL, {
        title: 'Create a new folder',
        buttonText: 'Create',
        isInSharedFoldersBeta: isInSharedFoldersBeta,
        buttonAction: (newFolderName, folderAccessControl) => {
          dispatch(
            addNewFolderWithStockItem(newFolderName, [], folderAccessControl)
          );
        },
      })
    );
  };

  return (
    <div className="text-center bg-gray-100 my-14 maker-md:mx-36 mx-4 py-10 maker-md:px-28 px-4 rounded-xl w-auto max-w-fit">
      <p className="mb-6 text-2xl">
        <b>There are no folders created yet!</b>
      </p>
      <p className="mb-6 text-xl">
        Create a new folder to start adding content to it.
      </p>
      <Button
        className="inline-block text-black no-underline"
        onClick={openNewFolderModal}
      >
        Create New Folder
      </Button>
    </div>
  );
};

export default NoFoldersHero;
